// Where to send the user once they log in, for pages reached from outside
// the app that need a logged-in user — e.g. the MCP consent page
// (/integracoes/assistente-ia/autorizar), which the AI assistant (Claude, ChatGPT, ...) opens with the OAuth request
// in the query string. Without this, logging in always lands on `/` and the
// request is lost.
//
// Kept in sessionStorage (this tab only, gone when it closes), and only ever
// a same-origin path, so it can't be turned into an open redirect.
const KEY = 'hall.postLoginRedirect'

const isSafePath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')

export const savePostLoginRedirect = (path) => {
  if (!isSafePath(path)) return
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // Storage blocked: the user just lands on `/` after logging in.
  }
}

// Returns the saved path (and forgets it), or null.
export const consumePostLoginRedirect = () => {
  try {
    const path = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return isSafePath(path) ? path : null
  } catch {
    return null
  }
}
